import { render, staticRenderFns } from "./SyncView.vue?vue&type=template&id=4e4881e6&scoped=true&"
import script from "./SyncView.vue?vue&type=script&lang=js&"
export * from "./SyncView.vue?vue&type=script&lang=js&"
import style0 from "./SyncView.vue?vue&type=style&index=0&id=4e4881e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4881e6",
  null
  
)

export default component.exports